import { Component, OnInit } from '@angular/core';
import * as Chart from 'chart.js';
import { DataStorageService } from '../../shared/data-storage.service';
import { AdminDashboardService } from '../admin-dashboard/admin-dashboard.service';
import { NGXLogger } from 'ngx-logger';
import {
  ViewAdminDashboard, ViewAdminDashboardResponse, ViewAdminTxnsDashboardGraphDataResponse,
  AdminPaymentKeyperFormanceIndicatorView, AdminTxnsStaticsView, AdminTxnsRegBillerView, BillerPerformance, TopBiller,
  TopBillerResp, AdminPaymentSuccessRateView, AdminPaymentTxnsAmountView, AdminPaymentTxnsAmountViewResp,
  NumberOfVisitors, InputOfVisitors, AssistedPerformance
} from '../admin-dashboard/view-admin-dashboard';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LeftMenu } from '../../shared/leftmenu/LeftMenu';
import { LoaderService } from '../../shared/loader/loader.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { Subscription } from '../../../../node_modules/rxjs';


@Component({
  selector: 'app-custom-dashboard',
  templateUrl: './custom-dashboard.component.html',
  styleUrls: ['./custom-dashboard.component.css']
})
export class CustomDashboardComponent implements OnInit {
  viewAdminDashboardResponse: ViewAdminDashboardResponse;
  viewAdminTxnsDashboardGraphDataResponse: ViewAdminTxnsDashboardGraphDataResponse;
  viewAdminDashboard: ViewAdminDashboard;
  adminPaymentKeyperFormanceIndicatorView: AdminPaymentKeyperFormanceIndicatorView;
  adminTxnsStaticsView: AdminTxnsStaticsView;
  adminTxnsRegBillerView: AdminTxnsRegBillerView;
  billerPerformance: BillerPerformance;
  assistedPerformance: AssistedPerformance;
  topBillerResp: TopBillerResp;
  adminPaymentSuccessRateView: AdminPaymentSuccessRateView;
  adminPaymentTxnsAmountViewResp: AdminPaymentTxnsAmountViewResp;
  adminPaymentTxnsAmountView: AdminPaymentTxnsAmountView;
  inputOfVisitors: InputOfVisitors;
  numberOfVisitors: NumberOfVisitors;

  public barChartData: any[];
  public barChartLabels: string[];
  public pieChartData: number[];
  public barChart2Data: any[];
  public barChart2Labels: string[];
  public barChartAssistedData: any[];
  public barChartAssistedLabels: string[];
  public hollowLineChartData: Array<any>;
  public hollowLineChartLabels: Array<any>;
  public LinePIChartData: Array<any>;
  public LinePIChartLabels: Array<any>;
  public linePISFChartData: Array<any>;
  public linePISFChartLabels: Array<any>;
  public lineSFChartLabels: Array<any>;
  public lineSFChartData: Array<any>;
  public lineChartData: Array<any>;
  public lineChartLabels: Array<any>;
  color: string = '#';

  loaderOff: number;
  numberOfTrans = 0;
  transactionAmount = 0;
  totalTxsnNo: number;
  totalTxsnAmnt: number;
  textHeading: string;

  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;
  activeDateRangeFlag: boolean = false;

  isDataRefresh: boolean = false;
  isRecentTransaction: boolean = false;
  isTopBillerAvail: boolean = false;

  isGetTxsnUpdate: Boolean = false;
  isTxsnReportUpdate: boolean = false;
  isKeyPerUpdate: boolean = false;
  isTxsnStaticsUpdate: boolean = false;
  isRegCitizenUpdate: boolean = false;
  isRegBillerUpdate: boolean = false;
  isTopRecordUpdate: boolean = false;
  isPITxsnUpdate: boolean = false;
  isPMTxsnUpdate: boolean = false;
  isPISuccFailUpdate: boolean = false;
  isPMSuccFailUpdate: boolean = false;
  idBillerPerUpdate: boolean = false;
  isAssistedUpdate: boolean = false;
  isVisitorUpdate: boolean = false;
  isGraphShowFlag: boolean = false;
  subscription: Subscription;
  lang: string;

  from_Date: string;
  to_Date: string;
  finalToDate: Date;

  finalMinDate:Date;
  maxDate: Date;
  ture: any;

  constructor(private dataStorageService: DataStorageService,
    private serviceAdmin: AdminDashboardService,
    private logger: NGXLogger,
    private router: Router,
    private pipe: DatePipe, private leftMenu: LeftMenu,
    private loaderService: LoaderService,
    private readonly translate: TranslateService
  ) { }

  ngOnInit() {

    let year = new Date().getFullYear()-5;
    let minDateFrom = year + "-" + '01' + "-" + '01';
    this.finalMinDate = new Date(minDateFrom);

    this.maxDate = new Date();

    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    window.scroll(0, 0);
    this.dataStorageService.setTabData("tabAdminDashboard");
    this.viewAdminDashboardResponse = new ViewAdminDashboardResponse();
    this.viewAdminTxnsDashboardGraphDataResponse = new ViewAdminTxnsDashboardGraphDataResponse();
    this.adminPaymentKeyperFormanceIndicatorView = new AdminPaymentKeyperFormanceIndicatorView();
    this.adminTxnsRegBillerView = new AdminTxnsRegBillerView();
    this.billerPerformance = new BillerPerformance();
    this.adminTxnsStaticsView = new AdminTxnsStaticsView();
    this.topBillerResp = new TopBillerResp();
    this.adminPaymentSuccessRateView = new AdminPaymentSuccessRateView();
    this.viewAdminDashboard = new ViewAdminDashboard();
    this.adminPaymentTxnsAmountViewResp = new AdminPaymentTxnsAmountViewResp();
    this.adminPaymentTxnsAmountView = new AdminPaymentTxnsAmountView();
    this.inputOfVisitors = new InputOfVisitors();
    this.viewAdminDashboard.mode = "web";
  }

  getDashboardDataOfADateRange(objDate1, objDate2) {
    //console.log("range data fatch");
    //this.logger.debug("custom dashboard...");
    let mm1 = new Date(objDate1).getMonth() + 1;
    let mm2 = new Date(objDate2).getMonth() + 1;
    let rStartDate = new Date(objDate1).getFullYear() + "-" + mm1 + "-" + new Date(objDate1).getDate();
    //console.log(rStartDate);
    let rangeStartDate = this.pipe.transform(rStartDate, 'yyyy-MM-dd');
    let rLastDate = new Date(objDate2).getFullYear() + "-" + mm2 + "-" + new Date(objDate2).getDate();
    let rangeLastDate = this.pipe.transform(rLastDate, 'yyyy-MM-dd');

    this.activeDateRangeFlag = true;
    this.isGraphShowFlag = true;
    this.viewAdminDashboard.datafor = "custom";
    this.viewAdminDashboard.startdate = rangeStartDate;
    this.viewAdminDashboard.enddate = rangeLastDate;

    this.getAdminTxnsDashboardGraphDataView();
    this.getAdminTxnsDashboardReportView();
    this.getAdminPaymentKeyperFormanceIndicatorView();
    this.getAdminTxnsStaticsView();
    this.getAdminTxnsRegCitizenView();
    this.getAdminTxnsRegBillerView();
    this.getAdminTopRecordsView();
    this.getNumberOfVisitor();
    this.getAdminPaymentSuccessRateViewPi();
    this.getAdminPaymentTxnsAmountViewPi();
    this.getAdminPaymentSuccessRateViewPm();
    this.getAdminPaymentTxnsAmountViewPm();
    this.getAdminBillerPerformanceView();
    this.getAssistedTransaction();
  }

  isLoaderOff() {
    // this.loaderService.hide();
  }

  limitOfTo() {
    let m;
    let d;
    let y;
    let nM;
    let nD;
    let nY;
    let maxDateForTo;
    m = new Date(this.from_Date).getMonth() + 1;
    d = new Date(this.from_Date).getDate();
    y = new Date(this.from_Date).getFullYear();
    if ((m == 1 || m == 3 || m == 8) && d == 31) {
      nM = m + 3;
      nD = 30;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if ((m == 1 || m == 3 || m == 8) && d != 31) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 2 || m == 4 || m == 9 || m == 5 || m == 6 || m == 7) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 10) {
      nM = 1;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && (d == 30 || d == 29)) {
      nM = 2;
      // nD = 28;
      let year = y + 1;
      let isLeap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0)
            isLeap = true;
          else
            isLeap = false;
        }
        else
          isLeap = true;
      }
      else {
        isLeap = false;
      }

      if (isLeap == true) {
        nD = 29;
      }
      else {
        nD = 28;
      }
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && !(d == 30 || d == 29)) {
      nM = 2;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 12) {
      nM = 3;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
  }


  //----------------------------------TRANSACTION AND AMOUNT BAR CHART 1-------------------------------------
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  //public barChartLabels: string[] = ['Mar 24', 'Mar 25', 'Mar 26', 'Mar 27', 'Mar 28', 'Mar 29', 'Mar 30'];
  //public barChartData: any[] = [
  //{
  //  data: [15, 10, 5, 13, 11, 8, 10], label: 'No. of transactions(in hundreds)', yAxisId: 'y-axis-1', fill: true,
  //},
  //{
  //  data: [15, 9, 5, 11, 9.5, 8.5, 9.2], label: 'Total amount (in lakh)', yAxisId: 'y-axis-2', fill: true,
  //}
  //];
  isRefresh: boolean = false;
  barChartOptions = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Number of Transactions', fontSize: 16, fontColor: '#8f3e92' },
              position: 'left', id: '1', type: 'linear',
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            },
            {
              scaleLabel: { display: true, labelString: 'Total Amount (in BDT)', fontSize: 16, fontColor: '#88c133' },
              position: 'right', id: '2', type: 'linear',
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public barChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(242,120,161,0.85)',
      borderColor: 'rgb(242,120,161)',
      pointBackgroundColor: 'rgba(242,120,161,0.85)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(242,120,161,0.85)'
    },
    {
      backgroundColor: 'rgba(178,190,234,0.8)',
      borderColor: 'rgb(178,190,234)',
      pointBackgroundColor: 'rgba(178,190,234,0.8)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(178,190,234,0.8)'
    }
  ];
  getNumberOfTransaction(arrayOfTrans: number[], arrayOfAmount: number[]) {
    this.numberOfTrans = 0;
    for (var i = 0; i < arrayOfTrans.length; i++) {
      this.numberOfTrans += arrayOfTrans[i];
    }
    // //this.logger.debug('transaction no in admin......... ' + this.numberOfTrans);
    this.transactionAmount = 0;
    for (var i = 0; i < arrayOfAmount.length; i++) {
      this.transactionAmount += arrayOfAmount[i];
    }
    //this.logger.debug('transaction no in admin......... ' + this.transactionAmount);



  }
  getAdminTxnsDashboardGraphDataView() {
    this.isGetTxsnUpdate = false;
    this.isRefresh = false;
    this.viewAdminTxnsDashboardGraphDataResponse = new ViewAdminTxnsDashboardGraphDataResponse();
    this.serviceAdmin.getAdminTxnsDashboardGraphDataView(this.viewAdminDashboard).subscribe((data) => {
      this.isGetTxsnUpdate = true;
      this.isRefresh = true;
      this.viewAdminTxnsDashboardGraphDataResponse = data.body as ViewAdminTxnsDashboardGraphDataResponse;
      this.getNumberOfTransaction(this.viewAdminTxnsDashboardGraphDataResponse.txns, this.viewAdminTxnsDashboardGraphDataResponse.amount);
      this.barChartData = [
        {
          data: this.viewAdminTxnsDashboardGraphDataResponse.txns, label: 'No. of Transactions', yAxisID: '1', fill: true,
        },
        {
          data: this.viewAdminTxnsDashboardGraphDataResponse.amount, label: 'Total Amount', yAxisID: '2', fill: true,
        }
      ]
      this.barChartLabels = this.viewAdminTxnsDashboardGraphDataResponse.timeperiod;
    })
  }
  public chartClicked(e: any): void {
    //console.log(e);
  }
  public chartHovered(e: any): void {
    //console.log(e);
  }
  //----------------------------------STATICS PIE CHART 1 DONE-----------------------------------------
  public pieChartLabels: string[] = ['Total Visitors', 'Bill Fetch', 'Bill Paid', 'Successful Transactions'];
  public pieChartType: string = 'pie';
  public pieChartColors: Array<any> = [
    {
      backgroundColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c'],
      borderColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c']
    }
  ];
  getAdminTxnsStaticsView() {
    this.isTxsnStaticsUpdate = false;
    this.serviceAdmin.getAdminTxnsStaticsView(this.viewAdminDashboard).subscribe((data) => {
      this.isTxsnStaticsUpdate = true;
      this.adminTxnsStaticsView = data.body as AdminTxnsStaticsView;
      this.pieChartData = [this.adminTxnsStaticsView.total_visitors, this.adminTxnsStaticsView.bill_fetch, this.adminTxnsStaticsView.bill_paid, this.adminTxnsStaticsView.success_txns];
    });
  }
  public chartPieClicked(e: any): void {
    //console.log(e);
  }
  public chartPieHovered(e: any): void {
    //console.log(e);
  }
  //--------------------------------NUMBER OF VISITORS LINE CHART 1------------------------------------------
  // public lineChartData: Array<any> = [
  //   { data: [65, 59, 80, 81, 56, 55, 40], label: 'No. of Visitors' },
  // ];
  // public lineChartLabels: Array<any> = ['Mar 24', 'Mar 25', 'Mar 26', 'Mar 27', 'Mar 28', 'Mar 29', 'Mar 30'];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales:
      {
        xAxes: [{
          maxRotation: 90,
          // minRotation: 90,
          ticks: {
            autoSkip: false,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Number of Visitors', fontSize: 16, fontColor: 'rgba(0,191,165,1)' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public lineChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(171,234,225,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
  ];
  public chartLineClicked(e: any): void {
    //console.log(e);
  }
  public chartLineHovered(e: any): void {
    //console.log(e);
  }

  getNumberOfVisitor() {
    this.isVisitorUpdate = false;
    this.inputOfVisitors.data_for = this.viewAdminDashboard.datafor;
    this.inputOfVisitors.start_date = this.viewAdminDashboard.startdate;
    this.inputOfVisitors.end_date = this.viewAdminDashboard.enddate;
    this.inputOfVisitors.mode = this.viewAdminDashboard.mode;
    // alert(JSON.stringify(this.inputOfVisitors));
    this.serviceAdmin.getNumberOfVisitor(this.inputOfVisitors).subscribe((data) => {
      this.numberOfVisitors = data.body as NumberOfVisitors;
      this.isVisitorUpdate = true;
      this.lineChartData = [
        { data: this.numberOfVisitors.no_of_visitors, label: 'Number of Visitors' }
      ];
      this.lineChartLabels = this.numberOfVisitors.date_hour;
    });
  }

  //--------------------------------------LINE CHART 2--------------------------------------------
  public hollowLineChartType: string = 'bar';       //line
  public hollowChartOptions: any = {
    type: 'bar',        //line
    maintainAspectRatio: false,
    responsive: true,
    fill: true,
    fillColor: '#e91e63',
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }

        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: '#e91e63' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  }
  public hollowChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: '#e91e63',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63'
    },
  ];
  getAdminPaymentTxnsAmountViewPi() {
    this.isPITxsnUpdate = false;
    this.adminPaymentTxnsAmountView.type = "pi";
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.startdate = this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    //alert(JSON.stringify(this.adminPaymentTxnsAmountView));

    this.serviceAdmin.getAdminPaymentTxnsAmountView(this.adminPaymentTxnsAmountView).subscribe((data) => {
      this.isPITxsnUpdate = true;
      this.adminPaymentTxnsAmountViewResp = data.body as AdminPaymentTxnsAmountViewResp;
      this.hollowLineChartData = [
        { data: this.adminPaymentTxnsAmountViewResp.total_amount, label: 'Transaction Amount', fill: false }
      ];
      this.hollowLineChartLabels = this.adminPaymentTxnsAmountViewResp.payment_name;
    });
  }
  public hollowLineClicked(e: any): void {
    //console.log(e);
  }
  public hollowLineHovered(e: any): void {
    //console.log(e);
  }
  //--------------------------------3Rd LINE CHART-------------------------------------------
  // public lineSFChartData: Array<any> =
  // [
  //   { data: [10, 10, 5, 4, 1, 7, 8, 2, 6, 8, 6, 4, 9, 5, 4], label: 'Failure' },
  //   { data: [90, 90, 95, 96, 99, 93, 92, 98, 94, 92, 94, 91, 95, 96, 99], label: 'Success' }
  // ];
  // public lineSFChartLabels: Array<any> = ['EBL', 'DBBL', 'City Bank', 'BRAC Bank', 'BKash', 'Rocket', 'Bank Asia', 'IBBL', 'PAYZA', 'DMoney', 'IPay', 'QCash', 'RFID', 'SEBL', 'UCBL'];
  public lineSFChartType: string = 'bar';     //line
  public lineSFChartOptions: any = {
    type: 'bar',          //line
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#0d9b8c' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public lineSFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: 'rgba(233,30,99,1)',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63',
    },
    {
      backgroundColor: '#0d9b8c',
      borderColor: '#0d9b8c',
      pointBackgroundColor: '#0d9b8c',
      pointBorderColor: '#0d9b8c',
      pointHoverBackgroundColor: 'rgba(13,155,140,0.4)',
      pointHoverBorderColor: 'rgba(13,155,140,1)'
    },
  ];
  getAdminPaymentSuccessRateViewPi() {
    this.isPISuccFailUpdate = false;
    this.adminPaymentTxnsAmountView.startdate = this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    this.adminPaymentTxnsAmountView.type = "pi";
    this.serviceAdmin.getAdminPaymentSuccessRateView(this.adminPaymentTxnsAmountView).subscribe((data) => {
      this.isPISuccFailUpdate = true;
      this.adminPaymentSuccessRateView = data.body as AdminPaymentSuccessRateView;
      this.lineSFChartData = [
        {
          data: this.adminPaymentSuccessRateView.success, label: 'Success'
        },
        {
          data: this.adminPaymentSuccessRateView.fail, label: 'Failure'
        }
      ]
      this.lineSFChartLabels = this.adminPaymentSuccessRateView.payment_name;
    });
  }
  //---------------------------------4th LINE CHART-------------------------------
  // public LinePIChartData: Array<any>  =
  //   [
  //     { data: [40000, 70000, 30000, 20000, 30000, 5000, 70000, 45000, 35000, 90000], label: 'Transaction Amount' },
  //   ];
  // public LinePIChartLabels: Array<any> = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];
  public LinePIChartType: string = 'bar'; line
  public ChartPIOptions: any = {
    type: 'bar',        //line
    maintainAspectRatio: false,
    // spanGaps: true,
    responsive: true,
    fill: true,
    fillColor: '7f93dc',
    // elements: {
    //   line: {
    //     tension: 0.000001
    //   }
    // },
    // plugins: {
    //   filler: {
    //     propagate: false
    //   }
    // },
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: '#7f93dc' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  }
  public LinePIChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(127,147,220,0.5)',
      borderColor: '#7f93dc',
      pointBackgroundColor: '#7f93dc',
      pointBorderColor: 'white',
      pointHoverBackgroundColor: '#7f93dc',
      pointHoverBorderColor: '#7f93dc'
    },
  ];
  getAdminPaymentTxnsAmountViewPm() {
    this.isPMTxsnUpdate = false;
    this.adminPaymentTxnsAmountView.type = "pm";
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.startdate = this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    this.serviceAdmin.getAdminPaymentTxnsAmountView(this.adminPaymentTxnsAmountView).subscribe((data) => {
      this.isPMTxsnUpdate = true;
      this.adminPaymentTxnsAmountViewResp = data.body as AdminPaymentTxnsAmountViewResp;
      this.LinePIChartData = [
        { data: this.adminPaymentTxnsAmountViewResp.total_amount, label: 'Transaction Amount', fill: false }
      ];
      this.LinePIChartLabels = this.adminPaymentTxnsAmountViewResp.payment_name;
    });
  }
  public LinePIClicked(e: any): void {
    //console.log(e);
  }
  public LinePIHovered(e: any): void {
    //console.log(e);
  }
  // ---------------------5th LINE CHART-------------------------------
  // public linePISFChartData: Array<any> =
  //   [
  //     { data: [0, 7, 3, 12, 8, 5, 9, 11, 4, 8], label: 'Failure' },
  //     { data: [100, 93, 97, 88, 92, 95, 91, 89, 96, 92], label: 'Success', fill: false }
  //   ];
  // public linePISFChartLabels: Array<any> = ['VISA', 'MASTER', 'AMEX', 'NEXUS', 'DINERS', 'MFS', 'E-BANKING', 'WALLET', 'ITCL', 'RFID'];
  public linePISFChartType: string = 'bar';       //line
  public linePISFChartOptions: any = {
    type: 'bar',        //line
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: { display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#ff9900' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  public linePISFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(0,191,165,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
    {
      backgroundColor: 'rgba(255,153,0,1)',
      borderColor: 'rgba(255,153,0,1)',
      pointBackgroundColor: 'rgba(255,153,0,1)',
      pointBorderColor: 'rgba(255,153,0,1)',
      pointHoverBackgroundColor: 'rgba(255,153,0,1)',
      pointHoverBorderColor: 'rgba(255,153,0,1)'
    },
  ];
  getAdminPaymentSuccessRateViewPm() {
    this.isPMSuccFailUpdate = false;
    this.adminPaymentTxnsAmountView.startdate = this.viewAdminDashboard.startdate;
    this.adminPaymentTxnsAmountView.enddate = this.viewAdminDashboard.enddate;
    this.adminPaymentTxnsAmountView.datafor = this.viewAdminDashboard.datafor;
    this.adminPaymentTxnsAmountView.mode = this.viewAdminDashboard.mode;
    this.adminPaymentTxnsAmountView.type = "pm";
    this.serviceAdmin.getAdminPaymentSuccessRateView(this.adminPaymentTxnsAmountView).subscribe((data) => {
      this.isPMSuccFailUpdate = true;
      this.adminPaymentSuccessRateView = data.body as AdminPaymentSuccessRateView;
      this.linePISFChartData = [
        {
          data: this.adminPaymentSuccessRateView.success, label: 'Success'
        },
        {
          data: this.adminPaymentSuccessRateView.fail, label: 'Failure'
        }
      ]
      this.linePISFChartLabels = this.adminPaymentSuccessRateView.payment_name;
    });
  }
  //----------------------------------Biller Performance 2nd BAR CHART-------------------------------
  public barChart2Type: string = 'bar';
  public barChart2Legend: boolean = true;
  public barChart2Options: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    //spanGaps: true,
    scaleShowVerticalLines: false,
    // legend: { display: false },
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [{
            scaleLabel: { display: true, labelString: 'No. of Transactions', fontSize: 15, fontColor: 'rgba(136,193,51,1)' },
            ticks: { min: 0, beginAtZero: true, fontSize: 13 }

          }]
      }
  };

  public assistedChart2Options: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    //spanGaps: true,
    scaleShowVerticalLines: false,
    // legend: { display: false },
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [{
            scaleLabel: { display: true, labelString: 'Total Amount of Transactions', fontSize: 15, fontColor: 'rgba(136,193,51,1)' },
            ticks: { min: 0, beginAtZero: true, fontSize: 13 }

          }]
      }
  };
  public getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    for (var i = 0; i < 6; i++) {
      this.color += letters[Math.floor(Math.random() * 16)];
    }
    return this.color;
  }
  public barChart2Colors: Array<any> = [
    {
      backgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      borderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointBackgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointBorderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointHoverBackgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointHoverBorderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)']
    }
  ];
  getAdminBillerPerformanceView() {
    this.idBillerPerUpdate = false;
    this.serviceAdmin.getAdminBillerPerformanceView(this.viewAdminDashboard).subscribe((data) => {
      this.idBillerPerUpdate = true;
      this.billerPerformance = data.body as BillerPerformance;
      this.barChart2Data =
        [
          {
            data: this.billerPerformance.no_of_txns, label: 'No. of transaction'
          }
        ]
      this.barChart2Labels = this.billerPerformance.blr_name;
      this.isDataRefresh = true;
    });
  }

  getAssistedTransaction(){
    //console.log("assisetd graph called")
    this.isAssistedUpdate = false;
    this.serviceAdmin.getAssistedPerformanceView(this.adminPaymentTxnsAmountView).subscribe((data) => {
      this.isAssistedUpdate = true;
      this.assistedPerformance = data.body as AssistedPerformance;
      this.barChartAssistedData =
        [
          {
            data: this.assistedPerformance.total_amount, label: 'Total amount of transaction'
          }
        ]
      this.barChartAssistedLabels = this.assistedPerformance.payment_name;
      this.isDataRefresh = true;
    });
  }

  public chart2Clicked(e: any): void {
    //console.log(e);
  }
  public chart2Hovered(e: any): void {
    //console.log(e);
  }
  // -------------------------- Tabular registers biller ---------------------------
  getAdminTxnsDashboardReportView() {
    this.isTxsnReportUpdate = false;
    this.serviceAdmin.getAdminTxnsDashboardReportView(this.viewAdminDashboard).subscribe((data) => {
      this.isTxsnReportUpdate = true;
      this.viewAdminDashboardResponse = data.body as ViewAdminDashboardResponse;
    });
  }
  // -------------------Key Performace Indicator------------------------------
  getAdminPaymentKeyperFormanceIndicatorView() {
    this.isKeyPerUpdate = false;
    this.serviceAdmin.getAdminPaymentKeyperFormanceIndicatorView(this.viewAdminDashboard).subscribe((data) => {
      this.isKeyPerUpdate = true;
      this.adminPaymentKeyperFormanceIndicatorView = data.body as AdminPaymentKeyperFormanceIndicatorView;
    });
  }
  //----------------------fetch admin txns reg citizen-----------------
  totalCitizenReg: number = 0;
  getAdminTxnsRegCitizenView() {
    this.isRegCitizenUpdate = false;
    this.serviceAdmin.getAdminTxnsRegCitizenView(this.viewAdminDashboard).subscribe((data) => {
      this.isRegCitizenUpdate = true;
      this.totalCitizenReg = data.body.reg_citizen;
    });
  }
  // ---------------------EkPay Registered Billers-----------------------
  getAdminTxnsRegBillerView() {
    this.isRecentTransaction = false;
    this.isRegBillerUpdate = false;
    this.serviceAdmin.getAdminTxnsRegBillerView(this.viewAdminDashboard).subscribe((data) => {
      this.isRegBillerUpdate = true;
      this.adminTxnsRegBillerView = data.body as AdminTxnsRegBillerView;
      if (this.adminTxnsRegBillerView.registered_billers == null) {
        this.isRecentTransaction = true;
      }
    });
  }
  // --------------------------fetch admin top records------------------
  getAdminTopRecordsView() {
    let topBiller = new TopBiller();
    this.isTopRecordUpdate = false;
    this.isTopBillerAvail = false;
    topBiller.datafor = this.viewAdminDashboard.datafor;
    topBiller.startdate = this.viewAdminDashboard.startdate;
    topBiller.enddate = this.viewAdminDashboard.enddate;
    topBiller.mode = this.viewAdminDashboard.mode;
    topBiller.recordfor = "biller";
    this.serviceAdmin.getAdminTopRecordsView(topBiller).subscribe((data) => {
      this.isTopRecordUpdate = true;
      this.loaderOff = 1;
      if (this.loaderOff == 1) {
        this.isLoaderOff();
      }
      this.topBillerResp = data.body as TopBillerResp;
      if (this.topBillerResp.top_records.length == 0) {
        this.isTopBillerAvail = true;
      }
    });
  }
  viewUser() {
    this.router.navigate(['/user/view']);
  }
  viewBiller() {
    this.router.navigate(['/biller/views']);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/custom-dashboard/custom-dashboard.component.ts